export const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : 'https://api-dev.greenchoice.io/api'
// export const API_URL = 'http://localhost:3000/api'
export const geoCodeAPIKEy = 'AIzaSyB8js5QCuoIkh_rxsTM8EPwjqXET8m8xwU'
export const DOWNLOAD_URL = 'https://s3.amazonaws.com/gcapp'
export const IS_DEV = true
export const FRESHDESK_URL = 'https://greenchoicenow.freshdesk.com/api/v2/tickets'
export const FRESHDESK_AUTH = {
  username: 'accounts@greenchoicenow.com',
  password: 'GreenChoice21!'
}




// WEBPACK FOOTER //
// ./src/constants.js